import { omitBy } from 'lodash';
import { stringify } from 'yaml';

export function asStringOrEmpty(value: any) {
    return typeof value == 'string' ? value : '';
}

export function objectToHumanString(value: any, omitNulls = false) {
    if (omitNulls) value = omitBy(value, x => x == null);

    return stringify(value);
}

export function softwareVersionToString(value?: Mri.DisplaySoftware.SoftwareVersion, allowNull?: boolean) {
    if (value) {
        if (value.extRevision > 0 || value.auxRevision > 0) {
            return `${value.productType}.${value.majorRevision}.${value.minorRevision}.${value.extRevision}.${value.auxRevision}`;
        } else {
            return `${value.productType}.${value.majorRevision}.${value.minorRevision}`;
        }
    } else return allowNull ? null : '-';
}
